import React from 'react';
import './App.css';
// route
import Router from './routes';
// i18n
import './translations/i18n';
// theme
import { ThemeProvider, LinearProgress } from '@mui/material';
import theme from './theme';
// hooks
import { useEffect, useState } from 'react';
import { AUTH_TOKEN } from './constants/message';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store';
import LoginView from './views/login';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { loginFailed, loginSuccess } from './store/authenticationSlice';
import { decode, encode } from './utils/hashString';

import axiosInstance from './lib/axios';
import { EN_ACCEPT_LANGUAGE, LA_ACCEPT_LANGUAGE } from './constants/acceptLanguageApi';
import { EMPLOYEE_GET_OFFICER_BY_TOKEN, EMPLOYEE_REFRESH_TOKEN, OFFICER_PROFILE_FIND_ONE } from './lib/endpoints/auth';
import { ADMIN_ORDER_FIND_ONE } from './lib/endpoints/order';
import { increaseNotification } from './store/notificationSlice';
import { OrderSocketModel } from './models/orderSocket';
import * as io from "socket.io-client";

function App() {
  const dispatch = useDispatch();
  const isAuth = useSelector((state: RootState) => state?.auth?.data);
  const isLoggedIn = useSelector((state: RootState) => state?.auth?.loggedIn);
  const auth = useSelector((state: RootState) => state?.auth)
  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants)

  const roleAdmin = useSelector((state: RootState) => state?.auth?.data?.role?.role_type)

  const [isInit, setIsInit] = useState<boolean>(false);

  const { i18n } = useTranslation("global");


  const getOfficerByToken = async () => {
    try {
      const authToken = localStorage.getItem(AUTH_TOKEN);
      const token: string = authToken ? decode(JSON.parse(authToken || '')?.accessToken || '') : '';
      axios.defaults.headers.common['Authorization'] = token;
      axiosInstance.defaults.headers.common['Authorization'] = token;
      const { data: dataEmployee } = await axios.post(
        EMPLOYEE_GET_OFFICER_BY_TOKEN
      );
      const { data: dataEmployeeProfile } = await axios.get(OFFICER_PROFILE_FIND_ONE);
      dispatch(loginSuccess({
        ...dataEmployee,
        profile: dataEmployeeProfile
      }));

    } catch (err: any) {
      if (err?.response?.status === 401) {
        try {
          const authToken = localStorage.getItem(AUTH_TOKEN);
          const refreshToken: string = authToken ? decode(JSON.parse(authToken || '')?.refreshToken || '') : '';
          axios.defaults.headers.common['Authorization'] = refreshToken;
          axiosInstance.defaults.headers.common['Authorization'] = refreshToken;

          const { data: dataRefreshToken } = await axios.post(
            EMPLOYEE_REFRESH_TOKEN
          );
          const { data: dataEmployee } = await axios.post(
            EMPLOYEE_GET_OFFICER_BY_TOKEN
          );
          const { data: dataEmployeeProfile } = await axios.get(OFFICER_PROFILE_FIND_ONE);
          localStorage.setItem(
            AUTH_TOKEN,
            JSON.stringify({
              accessToken: encode(refreshToken),
              refreshToken: encode(dataRefreshToken?.refreshToken),
            })
          );
          dispatch(loginSuccess({
            ...dataEmployee,
            profile: dataEmployeeProfile
          }));
        } catch (err2) {
          dispatch(loginFailed());
        }
      }
      else {
        dispatch(loginFailed());
      }

    }
  }

  const handleGetDataById = async (getId: string) => {
    try {
      const res = await axiosInstance.get(`${ADMIN_ORDER_FIND_ONE}?id=${getId}`);
      if (roleAdmin === 'SUPER_ADMIN') {
        dispatch(increaseNotification(res?.data));
      } else if (roleAdmin === 'ADMIN') {
        const merchantId = res?.data?.merchant?.id
        if (assignMerchantToAdmin?.find((item: any) => item === merchantId)) {
          dispatch(increaseNotification(res?.data));
        }
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    if (isAuth && !isInit) {

      const socket = io.connect(process.env.REACT_APP_SOCKET_URI || "");
      socket.on("current-order-from-user", (value: OrderSocketModel) => {
        if (!(isAuth?.role?.role_type === 'HR')) {
          handleGetDataById(value?.orderId);
        }
      })
      setIsInit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth])

  useEffect(() => {
    axiosInstance.defaults.headers.common['Accept-Language'] = i18n.language === "en" ? EN_ACCEPT_LANGUAGE : LA_ACCEPT_LANGUAGE;
    if (!isLoggedIn) {
      axios.defaults.headers.common['Accept-Language'] = i18n.language === "en" ? EN_ACCEPT_LANGUAGE : LA_ACCEPT_LANGUAGE;
      getOfficerByToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language])

  return (
    <ThemeProvider theme={theme}>
      {
        !isLoggedIn
          ?
          <LinearProgress />
          :
          isAuth
            ?
            <Router />
            :
            <LoginView />
      }
    </ThemeProvider>
  );
}

export default App;
